import { css } from 'styled-components';

// Generic type for the mapper object
type StylePropsMapper<T> = {
  [K in keyof T]: string;
};

// Utility function to map props to CSS
export const mapPropsToCss = <T extends object>(props: T, mapper: StylePropsMapper<T>, mediaQueries?: { [key: string]: T }) => {
  const baseStyles = Object.entries(mapper)
    .map(([key, cssProp]) => {
      if (props[key as keyof T]) {
        return `${cssProp}: ${props[key as keyof T]};`;
      }
      return '';
    })
    .join(' ');

  const mediaQueryStyles = mediaQueries
    ? Object.entries(mediaQueries)
        .map(([breakpoint, styles]) => {
          const breakpointStyles = Object.entries(mapper)
            .map(([key, cssProp]) => {
              if (styles[key as keyof T]) {
                return `${cssProp}: ${styles[key as keyof T]};`;
              }
              return '';
            })
            .join(' ');

          return `
            @media (max-width: ${breakpoint}) {
              ${breakpointStyles}
            }
          `;
        })
        .join(' ')
    : '';

  return css`
    ${baseStyles}
    ${mediaQueryStyles}
  `;
};
